/* START_MODULE_CONTRACT
 * PURPOSE: Конфигурация фронтенда: базовый URL API из окружения.
 * SCOPE: Экспорт объекта config с baseUrl.
 * DEPENDS: нет
 * LINKS: M-FE-API
 * ROLE: CONFIG
 * MAP_MODE: NONE
 * END_MODULE_CONTRACT
 *
 * START_MODULE_MAP
 * config - { baseUrl } из REACT_APP_BASE_URL или localhost:8080.
 * END_MODULE_MAP
 *
 * START_CHANGE_SUMMARY
 * LAST_CHANGE: 2026-07-02 - GRACE coverage: корректный module-контракт (CONFIG).
 * END_CHANGE_SUMMARY
 */

const config = {
  baseUrl: process.env.REACT_APP_BASE_URL || 'http://localhost:8080',
};

export default config;
